import Vue from "vue";
import Router from "vue-router";
import RecipesPage from "@/views/RecipesPage";
import RecipesFilterPage from "@/views/RecipesFilterPage";
import RecipesDetailPage from "@/views/RecipesDetailPage";
import SearchPage from "@/views/SearchPage";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      alias: "/recipes",
      name: "recipes",
      component: RecipesPage
    },
    {
      path: "/recipes-filter",
      name: "recipes-filter",
      component: RecipesFilterPage
    },
    {
      path: "/recipes/:url",
      name: "recipes-detail",
      component: RecipesDetailPage
    },
    {
      path: "/search",
      name: "search",
      component: SearchPage
    }
  ]
});
